import Button from '@mui/material/Button';
//import ArrowBack from '@mui/icons-material/ArrowBack';
import { Trans } from 'react-i18next';

export default function GoToOlcaButton() {

  return (
    <div style={{marginBottom: '20px'}}>
      <a href="https://www.olca.com.ar/" style={{textDecoration: 'none'}}>
          <Button className="come-back-to-olca">
            <Trans i18nKey={`screens.login.sections.main.comeToOlcaButton`}></Trans>
          </Button>
      </a>
      {/*<a href="https://www.olca.com.ar/" style={{textDecoration: 'none'}}>*/}
      {/*  <Button className="come-back-to-olca">*/}
      {/*    <Trans i18nKey={`screens.login.sections.main.ERPLoginLink`}></Trans>*/}
      {/*  </Button>*/}
      {/*</a>*/}
    </div>
  );
}